import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  Optional
} from '@angular/core';
import { SavedCartFacade } from '@spartacus/cart/saved-cart/root';
import {
  ActiveCartService,
  GlobalMessageService,
  GlobalMessageType,
  RoutingService,
  TranslationService
} from '@spartacus/core';
import { OutletContextData } from '@spartacus/storefront';
import { combineLatest, Subscription } from 'rxjs';
import { CartService } from '../cart.service';


@Component({
  selector: 'cart-order-summary',
  templateUrl: './order-summary.component.html',
  styleUrls: ['./order-summary.component.scss'],
})
export class CartOrderSummaryComponent implements OnInit, OnDestroy {
  public orderSummaryDetails: any = {};

  protected subscription = new Subscription();
  public cartValidationInProgress: boolean = false;

  isOOS: boolean[] = [];
  isPartiallyOOS: boolean[] = [];
  errorMessage: string[] = [];
  isSimulating: boolean = false;
  minQtyError: string | any;
  minValueError: string | any;
  lowInventory: string | any;
  tempOOS: string | any;
  constructor(
    private cartService: CartService,
    protected routingService: RoutingService,
    private globalMessageService: GlobalMessageService,
    private activeCart: ActiveCartService,
    protected savedCartService: SavedCartFacade,
    public cdf: ChangeDetectorRef,
    public translationService: TranslationService,
    @Optional() protected outlet?: OutletContextData<any>
  ) {
    this.subscription.add(
      this.cartService.onContinueBtnClick.subscribe((isClicked) => {
        if (isClicked) {
          this.validatingResponseWithErrorMessage();
        }
      })
    );

    this.subscription.add(
      this.activeCart.getActive().subscribe((data) => {
        this.orderSummaryDetails = data;
      })
    );
  }
  ngOnInit(): void {
    this.loadTranslations();
    this.initiateCartData();
  }

  loadTranslations() {
    combineLatest([
      this.translationService.translate('cartitemlistrow.errors.lowInventory'),
      this.translationService.translate('cartitemlistrow.errors.tempOOS')
    ]).subscribe((data) => {
      if (data) {
        this.lowInventory = data[0];
        this.tempOOS = data[1];
      }
      this.cdf.detectChanges();
    });
  }
  initiateCartData() {
    this.isPartiallyOOS = [];
    this.isOOS = [];
    this.errorMessage = [];
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_ERROR);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  disableButtonWhileNavigation() {
    this.cartValidationInProgress = true;
  }

  validatingResponseWithErrorMessage() {
    this.isSimulating = true;
    this.cartService.onContinueBtnClick.next(false);
    this.initiateCartData();
    this.subscription.add(
      this.cartService.updateOrderSimulate().subscribe(
        (responseData: any) => {
          this.isSimulating = false;
          this.cartService.cartEntryUpdates.next(responseData?.entries);
          this.orderSummaryDetails = responseData;
          responseData?.entries.map((item: any) => {
            this.isOOS.push(item?.isOOS);
            this.isPartiallyOOS.push(item?.isPartiallyOOS);
          });
          this.cartService.$orderSimulateResponse.next(responseData);

          if (responseData?.movOrMoqCode && responseData?.movOrMoqCode !== '') {
            combineLatest([this.translationService.translate('cartitemlistrow.errors.minOrderQnty', { value: responseData?.movOrMoqValue }),
            this.translationService.translate('cartitemlistrow.errors.minPriceValue', { value: responseData?.movOrMoqValue })]).subscribe(translate => {
              this.minQtyError = translate[0];
              this.minValueError = translate[1];
            })
            this.errorMessage.push(
              responseData?.movOrMoqCode === 'ZQ'
                ? this.minQtyError
                : this.minValueError
            );
          }
          if (
            this.isPartiallyOOS.length > 0 &&
            this.isPartiallyOOS.includes(true)
          ) {
            this.cartService.onButtonEnableDisable.next(true);
            this.errorMessage.push(this.lowInventory);
          }
          if (this.isOOS.length > 0 && this.isOOS.includes(true)) {
            this.cartService.onButtonEnableDisable.next(true);
            this.errorMessage.push(this.tempOOS);
          }

          if (this.errorMessage.length > 0) {
            this.errorMessage.forEach((msg) => {
              this.globalMessageService.add(
                msg ?? '',
                GlobalMessageType.MSG_TYPE_ERROR,
                60000
              );
            });
          } else {
            if (!responseData.isPricingError) {
              this.routingService.goByUrl('/review');
            }

          }
          this.cdf.detectChanges();
        },
        (error) => {
          this.isSimulating = false;
          this.cdf.detectChanges();
        }
      )
    );
  }
}
